import emeter_63_monophase_settings_gen_3 from '@devices/settings/common_settings/emeter_63_monophase_settings_gen_3';
import emeter_63_triphase_settings_gen_3 from '@devices/settings/common_settings/emeter_63_triphase_settings_gen_3';

export default {
	name: 'Shelly3EM63SlimG4',
	friendly_name: '3EM-63 Slim Gen4',
	family: 'emeter',
	isPM: true,
	modes: {
		monophase: {
			availableViews: ['basic'],
			channels: 3,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage'],
			phases: 3,
			settings: emeter_63_monophase_settings_gen_3,
		},
		triphase: {
			availableViews: ['basic'],
			channels: 1,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage'],
			phases: 3,
			settings: emeter_63_triphase_settings_gen_3,
		},
	},
};
